import { render, staticRenderFns } from "./FileCategorySelect.vue?vue&type=template&id=4267a6bd&scoped=true&"
import script from "./FileCategorySelect.vue?vue&type=script&lang=js&"
export * from "./FileCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267a6bd",
  null
  
)

export default component.exports